import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, DatePicker, Select } from 'antd';
import Ink from 'react-ink';
import dayjs from 'dayjs';
import moment from 'moment';
import '../topnav.css';
import { FieldTimeOutlined, ArrowRightOutlined } from '@ant-design/icons';


import {
	inspectionTimeUpdate
} from '../../../modules/analytics';

class TimeRangeModal extends Component {
	formRef = React.createRef();
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			message: null
		}
	}

	async componentDidUpdate(prevProps, prevStats) {
		const { show, inspectionTime } = this.props;
		if(show !== prevProps.show){
			this.setState({ inspectionTime: JSON.parse(JSON.stringify(inspectionTime))});
		}
	}

	handleSubmit = () => {
		const {inspectionTime } = this.state;
		this.setState({ loading: true });
		this.props.inspectionTimeUpdate(inspectionTime);
		this.setState({ loading: false });
		this.onClose();
	}

	onClose() {
		this.setState({
			message: null
		});
		this.props.toggleTimeRangeModal();
	}

	changeTill = (value) => {
		let {inspectionTime } = this.state;
		inspectionTime.till = value.startOf('hour').toISOString();
		this.setState(inspectionTime);
	}

	changeDays = (value) => {
		let {inspectionTime } = this.state;
		inspectionTime.day = value;
		this.setState(inspectionTime);
	}

	render() {
		const { loading, inspectionTime } = this.state;

		return (
			<Modal
				width={600}
				title={<span><FieldTimeOutlined /> Update Platform Sample Time Range</span>}
				open={this.props.show}
				onCancel={() => this.onClose()}
				footer={[
					<Button key="submit" type="primary"  onClick={this.handleSubmit.bind(this)} disabled={loading} ><Ink /><ArrowRightOutlined /> Submit</Button>,
					<Button key="back" onClick={this.onClose.bind(this)} disabled={loading}>Cancel</Button>
				]}
				maskClosable={false}
				closable={(loading) ? false : true}
				>
				{inspectionTime &&
					<div className="TimeRangeModal">
					<Select
								value={inspectionTime.day}
								onChange={this.changeDays.bind(this)}
					      style={{
					        width: 60,
					      }}
					      options={(new Array(31)).fill(0).map((j,i)=>({value:(i+1).toString(), label:(i+1).toString()}))}
					    />
					<span> day(s) till </span><DatePicker value={dayjs(inspectionTime.till)} allowClear={false} format={"YYYY-MM-DD HH:00"} disabledDate={(current) => current.isAfter(moment().add(1,'hour'))} showTime={{format:"hh"}} onChange={this.changeTill.bind(this)} />
					</div>
				}
			</Modal>
		);
	}
}
//<Slider style={{ width: '200px', margin: '30px' }} tooltipVisible={this.props.show && !loading} marks={marks} />

const mapStateToProps = state => ({
	router: state.router,
	inspectionTime: state.analytics.inspectionTime
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			inspectionTimeUpdate,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(TimeRangeModal);
